import { AmplitudeProvider } from "@crehana/analytics";
const AmplitudeLayout = AmplitudeProvider;
const Amplitude = AmplitudeLayout;
export default Amplitude;
